const siteName = 'Courier';
const siteTitle = 'Courier: how to work better and live smarter';
const siteDescription =
  'Stories of modern business. Work better, live smarter, be happier.';
const siteDefaultImage =
  '//images.ctfassets.net/l893v89mix1e/3ZLS0kR4UnK7EjUjNCIcOm/f43a7899ec293282150a5a6efdba21f0/C45_Cover_Social_Card.png';
const siteType = 'website';
const twitterCardStyle = 'summary_large_image';

module.exports = {
  siteDefaultImage,
  siteDescription,
  siteName,
  siteTitle,
  siteType,
  twitterCardStyle,
};
